import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserDetails, UserDetailsAction } from "../../ReduxTool/Slice/Auth/asyncHandlers";
import { resetReducerAnalysis, setProject3dAnalysisIframeURL } from "../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { setCardTitle } from "../../ReduxTool/Slice/Dashboard/DashboardReducer";
import { resetDrawer, setTitle, toggleDrawer } from "../../ReduxTool/Slice/Drawer/DrawerReducer";
import { toogleTooltip } from "../../ReduxTool/Slice/Map/MapReducer";
import { useAppDispatch, useAppSelector } from "../../ReduxTool/store/hooks";
import { logoutuser } from "../../Screen/User/UserApi";
import { jwtDecode } from "jwt-decode";
import { getAuthState, getUserType, logUserActivity } from "../../Utils/AuthRedirections";

import ShadowCast from "@arcgis/core/widgets/ShadowCast";
import { ParsedCountry } from "react-international-phone";
import { HamburgerMenuIcon, HelpIcon, ProfileIcon, WhatsNewIcon } from "../../assests/icons/Icons";
import logoImage from "../../assests/svg/Terranxt Logo.svg";
import { ProfileTy, SupportDTy } from "../../Components/AllInput/types";
import Toast from "../../Components/ErrorBoundry/Toast";
import { NewModal } from "../../Components/New/Modal/NewModal";
// import ProfileOptionModal from "../../Components/New/Modal/ProfileModal/ProfileOptionModal";
import SuccessModal from "../../Components/New/Modal/SuccessModal";
import ChangePassword from "../../Components/ProfileModal/ChangePassword";
import ProfileModal from "../../Components/ProfileModal/ProfileModal";
import SettingModal from "../../Components/ProfileModal/settings/SettingModal";
import Support from "../../Components/ProfileModal/Support";
import ReactTooltip from "../../Components/ReactTooltip/ReactTooltip";
import { getSupportSubjListCon, sendSupportRequest } from "../../ReduxTool/Slice/CommonReducers/CommonActions";
import { setModalHeaderFooter } from "../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { signUPDetails } from "../../Screen/User/SignUp";
import { baseURL, requestUrl } from "../../Utils/baseUrls";
import { convertImageToBase64, getNumberOfWords, getPasswordErrMsg, handleBase64ToImage, isValidName, testPassword } from "../../Utils/commonFunctions";
import { getLocalMobileDigits, loadMobileCountries, validateCountryMobile } from "../../Utils/mobileValidation";
import { countryJsonType } from "../../ReduxTool/Slice/Auth/types";
import { CurrencyTy, FORMTOASTERRID, ProfileModalOptions, ProfileModalOptionsTy, PROPOSAL_PAYMENT_PACKAGE_ID, suportRequestTy, UnitSelection } from "../../Utils/Const";
import globalLayers from "../../Utils/CustomerMaps/Maps/GlobaLMap";
import { removeSearchedGraphic } from "../../Utils/CustomerMaps/Maps/removeSearchedLocationGraphic";
import { fetchChildWMSLayersByParentId_byBaseLayer } from "../../Utils/Fetch3D/fetchRoof";
import { validPassword } from "../../Utils/Regex";
import { switchView } from "../../lib/Customer/SwitchMap";
import LoadingScreen from "../../Components/Loader/LoadingScreen";
import { store } from "../../ReduxTool/store/store";
import { ProjectTy } from "../../ReduxTool/Slice/Auth/types";
import { getStateListByCountryID } from "../../ReduxTool/Slice/GeneralSlice/CountrySlice";
import SupportTrack from "../../Components/ProfileModal/SupportTrack";
import ProposalModal from "../../Screen/Consumer/RoofAnalysis/Proposal/ProposalModalMain";
import { FileData } from "../../Components/Upload.tsx/VInputUpload";
import { saveConsumerProjects } from "../../ReduxTool/Slice/Consumer/ProjectServices/projectServices";
import { BillingBasis, getPaymentStatus, hasPaidPackageForProject, hasUnconfirmedPayment, paymentErrorMessage, startPayUCheckout, takeCompletedPayment } from "../../lib/payments/payu";
import UserProfilePortal from "./UserProfile/UserProfilePortal";
import ProfileOptionModal from "../../Components/New/Modal/ProfileModal/ProfileOptionModal";
import { ModalId } from "../../Components/New/Modal/ProfileModal/Const";
export interface StaticTooltipTy {
  content: string | JSX.Element; toolTipid: string; place?: "left" | 'right' | 'top' | 'bottom',
  isopen?: boolean
}

export type ProfileModalType = | "view" | "setting" | "support" | "supporttrack" | "proposal" | "password" | "units&region" | "notification" | "language" | null;
export interface ModalHeaderFooter { title: string; btnTxt: string; secondaryBtnTxt: string; data?: any, isheader?: boolean; modalid?: string; }

const openViewProfileModal = (modalTy: ProfileModalType) => {
  // ...
};


const headerTitleList = {
  "/Consumer": "Dashboard",
  "/Consumer/RoofAnalysis": "Project Setup",
}


const DefaultHeader = () => {

  // Hooks
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const { pathname } = useLocation();
  const userType = getUserType();

  // Redux state
  const { user: username, isState } = useAppSelector((state) => state.auth);
  const { title, displayDrawer } = useAppSelector((state) => state.drawer);
  const { supportSubjectList, allDiscom, modal: { modalid, title: modalTitle, btnTxt, secondaryBtnTxt, isheader } } = useAppSelector(state => state.commonReducers)
  const { selected_project } = useAppSelector(state => state.consumerReducers.roofAnalysis)
  const { CountrySlice } = useAppSelector(state => state)
  // const {  } = useAppSelector((state) => state.commonReducers.modal);

  const headerTitle = headerTitleList[pathname as keyof object]
  const user = useAppSelector((state) => state.auth.user);
  // const headerTitle = getActivePageTitle(pathname, pathname == `/${userType}/RoofAnalysis` ? title : "");


  // Local state
  const [openProfile, setOpenProfile] = useState(false)
  const [uname, setUname] = useState({ fname: "", lname: "" });
  // state for show hide 3d fetch data 
  const [show, hide] = useState(false)
  const [iframeUrl, setIframeUrl] = useState("");

  const [viewProfileDetails, setViewProfileDetails] = useState<ProfileTy>({ fname: "", lname: "", userEmail: "", userMobile: "", countrycode: "", isvalid: true, profileimage: "" })
  const [supportDetails, setSupportDetails] = useState<SupportDTy>({ fname: "", lname: "", mobile: "", countrycode: "", subject: null, message: "", email: "" })
  const [settings, setSettings] = useState({ language: { label: "English", value: "English" }, units: "Meters", currency: { label: "INR", value: "INR" } })

  const [profileModals, setProfileModals] = useState<ProfileModalOptions>({ view: false, setting: false, support: false, supporttrack: false, password: false, message: "", success: false, proposal: false })
  const [isEditing, setIsEditing] = useState<ProfileModalOptionsTy>({ view: false, setting: false, support: true, password: false })
  const [passwordHide, setPasswordHide] = useState({ oldpassword: false, newpassword: false, cpassword: false })

  const [units, setUnits] = useState<UnitSelection>({ unitsType: "Imperial", LengthDistance: "Yard (yd)", MassWeight: "Pound (lb)", CapacityVolume: "Pint", Temperature: "Fahrenheit (°F)", Time: "Second (s)" })
  const [supportSuccess, setSupportSuccess] = useState<{ show: boolean; ticketCode: string }>({ show: false, ticketCode: "" });
  const [currency, setCurrency] = useState<CurrencyTy>({ currency: "India (INR)" })
  const [openHamburgerProfile, setOpenHamburgerProfile] = useState<boolean>(false)
  const [proceedToPaymentLoading, setProceedToPaymentLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState('')
  const [error, setError] = useState({});

  const [changePasswordIn, setChangePasswordIn] = useState<signUPDetails[]>([
    { name: "oldpassword", label: "Old password", value: "", error: "", type: "password" },
    { name: "newpassword", label: "New password", value: "", error: "", type: "password" },
    { name: "cpassword", label: "Confirm password", value: "", error: "", type: "password" }
  ])

  // UseRef state 

  const profileModalRef = useRef<HTMLDivElement>(null)
  const headerProfile = useRef<HTMLDivElement>(null);
  const hamburgerMenuRef = useRef<HTMLDivElement>(null);
  const hamburgerProfileRef = useRef<HTMLDivElement>(null);
  const successModalRef = useRef<HTMLDivElement>(null)


  const imageFile = handleBase64ToImage(username?.image ?? "")

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    if (!userid) {
      logoutuser(dispatch, Navigate);
    }
    // Stored userid must belong to the stored token (except admin "open as user" links, which pair them on purpose)
    try {
      const tokenUserId = (jwtDecode(localStorage.getItem("token") ?? "") as { userid?: string }).userid;
      if (userid && tokenUserId && tokenUserId !== userid && localStorage.getItem("userType") !== "Admin") {
        logoutuser(dispatch, Navigate);
        return;
      }
    } catch { /* unreadable token: getAuthState already treats it as expired */ }

    if (Object.keys(user).length) return;
    const fetchUserDetails = async (userid: string) => {
      try {
        const response = await dispatch(getUserDetails(userid)).unwrap();
        if (pathname === "/Consumer/RoofAnalysis" && response.projects?.length === 2 && !sessionStorage.getItem("projectid")) {
          Navigate("/Consumer");
        }
        if ((response?.projects?.length ?? 0) > 0 && pathname !== "/Consumer/RoofAnalysis") {
          Navigate("/Consumer")
        }
        if (!response) {
          logoutuser(dispatch, Navigate);
        }
      } catch (err: any) {
        // Deleted/deactivated account: the local token is still unexpired, so log out explicitly
        if (err?.accountGone) {
          Toast({ messageText: "Your account is no longer active. Please sign in again.", messageType: "E", toastId: FORMTOASTERRID });
          logoutuser(dispatch, Navigate);
        }
      }
    };
    fetchUserDetails(userid!);

    // dispatch(getUserDetails(userid));
    // dispatch(getPrtojects(userid));
    // removeSearchedGraphic();
    //need to check handling
    // navigate(localStorage.getItem('url')!)
  }, []);
  useEffect(() => {
    // fetch state list on behalf of country id 
    if (user && user.country_mstr && user.country_mstr.countryid) {
      dispatch(getStateListByCountryID(user?.country_mstr?.countryid))
    }
  }, [user?.country_mstr])
  useEffect(() => {
    if (user) {
      const img = handleBase64ToImage(user?.image ?? "")
      setUname({
        fname: user?.fname?.split("")[0] ?? "",
        lname: user?.lname!?.split("")[0] ?? "",
      });
      setViewProfileDetails({ fname: user.fname ?? "", lname: user.lname ?? "", userEmail: user.emailid, userMobile: `${user.country_mstr?.countrycode}${user.mobile}`, countrycode: user.country_mstr?.countrycode ?? "", isvalid: true, profileimage: img ?? "" })
    }
  }, [user]);

  useEffect(() => {
    if (title) {
      const dd = document.getElementById("searchDiv-suggest-menu") as HTMLElement;
      if (dd) {
        dd.style.marginLeft = "7rem";
      }
    } else {
      const dd = document.getElementById("searchDiv-suggest-menu") as HTMLElement;
      if (dd) {
        dd.style.marginLeft = "0rem";
      }
    }
  }, [title]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const searchbox = document.getElementById("searchDiv-suggest-menu");
      if (searchbox) {
        searchbox.classList.toggle("hidden", (!isheader && !!modalTitle));
      }
    });

    const container = document.getElementById("searchDiv");
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, [isheader]);


  const logout = async (e: { preventDefault: () => void }) => {
    setOpenProfile(false)
    dispatch(toogleTooltip({ dipy: 0, istooltip: "", msg: "" }));
    removeSearchedGraphic();
    e.preventDefault();
    localStorage.clear();
    sessionStorage.clear();
    dispatch(setTitle(""));
    dispatch(toggleDrawer(false));
    dispatch(resetDrawer());
    dispatch(resetReducerAnalysis());
    if (globalLayers.selectedGraphic) {
      globalLayers.selectedGraphic = null;
    }
    Navigate("/");
    logUserActivity("logout", dispatch);
    dispatch(setCardTitle("Recent"));
    return false;
  };

  const handleClickLogo = () => {
    dispatch(toggleDrawer)
    dispatch(setTitle(""));
    let {
      user: { role, hassceen },
    } = getAuthState(),
      location = "/";
    if (!role) localStorage.clear();
    sessionStorage.clear();
    if (globalLayers.selectedGraphic) {
      globalLayers.selectedGraphic = null;
    }
    if (role && role.toLowerCase().includes("admin")) {
      location = `/`;
    } else if (role && role.toLowerCase().includes("partner")) {
      location = `/`;
    } else {
      location = `/${role}`;
    }
    window.location.href = location;
  };

  const profileHandler = () => {
    // setOpenProfile((prev) => !prev);
    if (modalid === "profileoptionmodal") {
      dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false, modalid: "" }))
    } else {      // if(modalTitle === "" && modalid !== "profileoptionmodal") {
      dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false, modalid: "profileoptionmodal" }))
    }
  };

  const profileHandlerOutside = (modalId: string) => {
    // console.log("Modal id at runnn  -->>     ",modalid   )
    // setOpenProfile((prev) => !prev);
    // if (modalId === "profileoptionmodal") {
    dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false, modalid: "" }))
    // }
  };

  const openViewProfileModal = (modalTy: ProfileModalType) => {
    let modalHeaderFooter: ModalHeaderFooter = { title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false }
    switch (modalTy) {
      case "view":
        modalHeaderFooter = { title: "User Profile", btnTxt: "Edit", secondaryBtnTxt: "", isheader: true, modalid: "userprofileeditmode" }
        profileHandler()
        break
      case "support":
        if (!supportSubjectList.length) {
          dispatch(getSupportSubjListCon())
        }
        setSupportDetails({ email: user.emailid ?? "", fname: user.fname, lname: user.lname ?? "", mobile: user.mobile ? `${user.country_mstr?.countrycode ?? ""}${user.mobile}` : "", countrycode: user.country_mstr?.countrycode ?? "", subject: null, message: "" })
        modalHeaderFooter = { title: "Support", btnTxt: "Submit Request", secondaryBtnTxt: "", isheader: true, modalid: "supportsystem" }
        break
      case "proposal":
        setStepApproval(1);
        modalHeaderFooter = { title: "Review your proposal", btnTxt: "Continue to Agreement", secondaryBtnTxt: "Talk to Support", isheader: true }
        break
      case "supporttrack":
        modalHeaderFooter = { title: "Track Request", btnTxt: "", secondaryBtnTxt: "", isheader: true }
        break
      case "setting":
        modalHeaderFooter = { title: "Settings", btnTxt: "Edit", secondaryBtnTxt: "", isheader: true }
        profileHandler()
        break
      case "password":
        modalHeaderFooter = { title: "Change Password", btnTxt: "Update", secondaryBtnTxt: "", isheader: true }
        profileHandler()
        break;
      case null:
        setProfileModals({ view: false, setting: false, support: false, password: false, message: "", success: false, supporttrack: false, proposal: false })
        modalHeaderFooter = { title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false, modalid: "" }
        break;
      default:
        break
    }
    dispatch(setModalHeaderFooter(modalHeaderFooter))
    setProfileModals(prev => ({ ...prev, [modalTy as keyof object]: true }))
  }

  const updateUserProfile = async () => {
    let mobileCountry: countryJsonType | undefined;
    try {
      const countries = await loadMobileCountries();
      mobileCountry = countries.find(country => country.countryid === user.countryid ||
        country.alpha2code === user.country_mstr?.alpha2code);
    } catch {
      setError({ userMobile: "Unable to load mobile validation. Please try again." });
      return;
    }
    const isValid = validateForm("profile", mobileCountry)
    let imageString;
    if (viewProfileDetails.profileimage) {
      imageString = await convertImageToBase64(viewProfileDetails.profileimage)
    }

    if (isValid) {
      const reqbody = {
        fname: viewProfileDetails.fname,
        lname: viewProfileDetails.lname,
        emailid: viewProfileDetails.userEmail,
        mobile: getLocalMobileDigits(viewProfileDetails?.userMobile ?? "", user.country_mstr?.countrycode),
        image: imageString,
      }
      let { payload } = await dispatch(UserDetailsAction({ reqBody: reqbody, userid: user.userid }))
      if (payload !== 'string') {
        setIsEditing(prev => ({ ...prev, view: false, }))
        openViewProfileModal(null)
        setProfileModals(prev => ({ ...prev, view: false, success: true, message: "Your profile has been updated successfully." }))
        setError({});
      }
    }
  }

  const updateSettings = () => {
    const isvalid = validateForm("setting")
    if (isvalid) {
      setIsEditing(prev => ({ ...prev, setting: false }))
      setError({})
      setProfileModals(prev => ({ ...prev, setting: false }))
    }
  }

  const handleViewProfileUpdate = (title: string) => {
    if (isEditing.view === false && title === "User Profile") {
      dispatch(setModalHeaderFooter({ title: "User Profile", btnTxt: "Save", secondaryBtnTxt: "Cancel", isheader: true }));
      setIsEditing(prev => ({ ...prev, view: true }))
    }
    else {
      switch (title) {
        case "User Profile":
          updateUserProfile()
          break;
        case "Cancel":
          setViewProfileDetails({ fname: user.fname, lname: user.lname, userEmail: user.emailid, userMobile: `${user.country_mstr?.countrycode}${user.mobile}`, isvalid: true, countrycode: user.country_mstr?.countrycode ?? "", profileimage: imageFile })
          dispatch(setModalHeaderFooter({ title: "User Profile", btnTxt: "Edit", secondaryBtnTxt: "", isheader: true }));
          setIsEditing(prev => ({ ...prev, view: false }))
          setError({})
          break;
      }
    }
  }

  const handleSettingsUpdate = (title: string) => {
    if (isEditing.setting === false && title === "Settings") {
      dispatch(setModalHeaderFooter({ title: "Settings", btnTxt: "Save", secondaryBtnTxt: "Cancel" }));
      setIsEditing(prev => ({ ...prev, setting: true }))
    }
    else {
      switch (title) {
        case "Settings":
          updateSettings()
          break;
        case "Cancel":
          // setViewProfileDetails({fname:user.fname ,lname: user.lname,userEmail:user.emailid,userMobile:`${user.country_mstr?.countrycode}${user.mobile}`,isvalid:true,countrycode:user.country_mstr?.countrycode??"",profileimage:imageFile})
          dispatch(setModalHeaderFooter({ title: "Settings", btnTxt: "Edit", secondaryBtnTxt: "" }));
          setIsEditing(prev => ({ ...prev, setting: false }))
          setError({})
          break;
      }
    }
  }

  const handleViewProfileModalClose = (modalTy: string) => {
    if (modalTy === "view") {
      setViewProfileDetails({ fname: user.fname, lname: user.lname, userEmail: user.emailid, userMobile: `${user.country_mstr?.countrycode}${user.mobile}`, isvalid: true, countrycode: user.country_mstr?.countrycode ?? "", profileimage: imageFile })
    }
    else if (modalTy === "setting") {
      setSettings({ language: { label: "English", value: "English" }, units: "Meters", currency: { label: "INR", value: "INR" } })
    }
    else if (modalTy === "support") {
      setSupportDetails({ email: user.emailid ?? "", fname: user.fname, lname: user.lname ?? "", mobile: user.mobile ? `${user.country_mstr?.countrycode ?? ""}${user.mobile}` : "", countrycode: user.country_mstr?.countrycode ?? "", subject: null, message: "" })
      setUploadFile("")
      setUploadFileNames([])
      setSupportSuccess({ show: false, ticketCode: "" })
    }
    else if (modalTy === "password") {
      const resetPasswordValues = changePasswordIn.map(each => ({ ...each, value: "" }))
      setChangePasswordIn(resetPasswordValues)
    }
    setProfileModals(prev => ({ ...prev, [modalTy]: false, }))
    setIsEditing(prev => ({ ...prev, [modalTy]: false }))
    setError({});
    dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false }))
  }

  const validateForm = (name: string, mobileCountry?: countryJsonType) => {
    let isValid = true;
    let mobileErrorMsg = "Please enter a valid mobile number";
    const errors: Record<string, string> = {};
    const validateFinalMobile = () => {
      const mobileNo = getLocalMobileDigits(viewProfileDetails?.userMobile ?? "", user.country_mstr?.countrycode);
      const error = validateCountryMobile(mobileNo, mobileCountry);
      if (error) mobileErrorMsg = error;
      return !error;
    }

    const validations = {
      "support": [
        { field: "fname", condition: !supportDetails.fname, message: "This field is required" },
        { field: "lname", condition: !supportDetails.lname, message: "This field is required" },
        { field: "subject", condition: !supportDetails.subject, message: "This field is required" },
        { field: "message", condition: !supportDetails.message, message: "This field is required" },
      ],
      "profile": [
        { field: "fname", condition: !viewProfileDetails.fname, message: "This field is required" },
        { field: "lname", condition: !viewProfileDetails.lname, message: "This field is required" },
        // validate no here..
        { field: "userMobile", condition: !validateFinalMobile(), message: mobileErrorMsg },
        { field: "userEmail", condition: !viewProfileDetails.userEmail, message: "This field is required" },
      ],
      "setting": [
        { field: "language", condition: !settings.language, message: "This field is required" },
        { field: "units", condition: !settings.units, message: "This field is required" },
        { field: "currrency", condition: !settings.currency, message: "This field is required" },
      ],
      "password": [
        { field: "oldpassword", condition: !changePasswordIn[0].value, message: `${"This field is required"}` },
        { field: "newpassword", condition: !changePasswordIn[1].value || changePasswordIn[0].value === changePasswordIn[1].value || !validPassword.test(changePasswordIn[1].value!) || changePasswordIn[1].value.length < 8, message: getPasswordErrMsg({ newPassword: changePasswordIn[1]?.value ?? "", confirmPassword: changePasswordIn[2]?.value ?? "", oldPassword: changePasswordIn[0]?.value ?? "" }) },
        { field: "cpassword", condition: changePasswordIn[1].value !== changePasswordIn[2].value || !changePasswordIn[2].value, message: `${!changePasswordIn[2].value ? "This field is required" : "Confirm password must match new password"}` },
      ]
    };

    for (const { field, condition, message } of validations[name as keyof object] as any) {
      if (condition) {
        errors[field] = message;
        isValid = false;
      }
      else if (error) {
        delete error[field as keyof object];
        setError(error);
      }
    }
    if (Object.keys(errors).length > 0) {
      setError(errors);
    };
    return isValid;
  };

  const handleSupport = async () => {
    const isFormValid = validateForm("support");
    if (!isFormValid) return;
    setIsModalLoading("User Profile")
    const reqbody = {
      subjectid: supportDetails.subject?.value,
      message: supportDetails.message,
      files: uploadFile || undefined,
    } as suportRequestTy;
    try {
      const response = await sendSupportRequest(reqbody);

      if (response?.status === 200 && response?.data?.ticketCode) {                          // ← check ticketCode in response
        Toast({ messageText: "Support successfully submitted.", messageType: "S", autoClose: 1000, toastId: "SupportRequest" });
        setSupportSuccess({ show: true, ticketCode: response?.data?.ticketCode });
        setSupportDetails({ email: user.emailid ?? "", fname: user.fname, lname: user.lname ?? "", mobile: user.mobile ? `${user.country_mstr?.countrycode ?? ""}${user.mobile}` : "", countrycode: user.country_mstr?.countrycode ?? "", subject: null, message: "" })
        setUploadFile("")
        setUploadFileNames([])
        setError({});
      }
    } catch (err: any) {
      Toast({ messageText: "Something Went Wrong", messageType: "E", toastId: FORMTOASTERRID, autoClose: 1000 });
    }

    setIsModalLoading("")
  }

  const changePassword = async () => {
    const isFormValid = validateForm("password");
    if (isFormValid) {
      const reqbody = {
        oldpassword: changePasswordIn[0].value,
        newpassword: changePasswordIn[2].value
      };
      try {
        const { data } = await baseURL.put(`${requestUrl.changeUserPassword}/${user.userid}`, reqbody);
        if (data && data.code === "200") {
          // Toast({messageText:"Password update successfully.",messageType:"S",autoClose:1000,toastId:"UpdatedPasseord"});
          openViewProfileModal(null)
          setProfileModals({ ...profileModals, password: false, success: true, message: "Your password has been changed successfully." });
          const resetPasswordValues = changePasswordIn.map(each => ({ ...each, value: "" }))
          setChangePasswordIn(resetPasswordValues)
          setError({});
        };
      } catch (err: any) {
        console.log(err)
        setError(prev => ({ ...prev, oldpassword: err.response.data.message }))
      }
    }
  }

  const handleChangePasswordClick = (title: string) => {

    switch (title) {
      case "Change Password":
        changePassword()
        break;
      case "back":
        const resetPasswordValues = changePasswordIn.map(each => ({ ...each, value: "" }))
        setChangePasswordIn(resetPasswordValues)
        setProfileModals(prev => ({ ...prev, password: false }))
        setError({})
        break;
      default:
        break;
    }
  }

  const handlePasswordChangeEl = (e: any, index: number) => {
    const { name, value } = e.target
    if (!testPassword(value) && value !== "") {
      return false;
    }

    setChangePasswordIn((prev: any) => {
      prev[index].value = value
      return [...prev]
    })
    if (error) {
      setError((prev: any) => ({ ...prev, oldpassword: !prev.oldpassword ? null : prev.oldpassword, [name]: null }));
    }
  }


  const handleChange = (e: any, statename: string, selectedOption?: any) => {
    let { name, value } = e?.target ?? e;
    if (selectedOption) {
      name = selectedOption.name;
      value = e;
    }
    let valueErr = false
    if (name === "fname" || name === "lname") {
      if (value.length > 20 || value === " " || !isValidName(value)) {
        valueErr = true
      }
      valueErr && e.preventDefault()
    }
    if (value === "") {
      valueErr = false
    }


    if (!valueErr) {
      if (statename === "support") {
        if (name === "message" && getNumberOfWords(value, 200)) {
          return
        }
        setSupportDetails({ ...supportDetails, [name]: value });
      } else if (statename === "setting") {
        setSettings(prev => ({ ...prev, [name]: value }))
      } else if (statename === "profile") {
        setViewProfileDetails(prev => ({ ...prev, [name]: value }))
      }
      if (error && error[name as keyof object]) {
        delete error[name as keyof object];
        setError(error);
      }
    }

  }

  const handleSettings = async (props: any, tabname: string, selectedOption?: any) => {
    let { name, value } = props?.target ?? props;
    if (tabname === "units") {
      if (name === "unitsType") {
        if (value === "Imperial") {
          setUnits(prev => ({ ...prev, [name]: value, LengthDistance: "Yard (yd)", MassWeight: "Pound (lb)", CapacityVolume: "Pint", Temperature: "Fahrenheit (°F)", Time: "Second (s)" }))
        }
        else {
          setUnits(prev => ({ ...prev, [name]: value, LengthDistance: "Meter (m)", MassWeight: "Kilogram (kg)", CapacityVolume: "Liter (L)", Temperature: "Celsius (°C)", Time: "Second (s)" }))
        }
      } else {
        setUnits(prev => ({ ...prev, [name]: value }))
      }
    }
    if (tabname === "currency") {
      setCurrency(prev => ({ ...prev, [name]: value }))
    }
    if (selectedOption) {
      name = selectedOption.name;
      value = props;
    };
    setSettings(prev => ({ ...prev, [name]: value }))
  }

  const handleMobileNumber = async (phone: string, country: ParsedCountry) => {
    if (!phone.startsWith(viewProfileDetails.countrycode)) {
      if (phone.startsWith('+')) { phone = phone.replace(/^\+\d*/, ''); }
      phone = `${viewProfileDetails.countrycode}${phone}`;
    }
    const isValid = !validateCountryMobile(getLocalMobileDigits(phone, user.country_mstr?.countrycode), user.country_mstr);
    setViewProfileDetails(prev => ({ ...prev, userMobile: phone, isvalid: isValid }))
    if (error && error["userMobile" as keyof object]) {
      delete error["userMobile" as keyof object];
      setError(error);
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {

      if (profileModalRef.current && headerProfile.current && !profileModalRef.current.contains(event.target as Node) && !headerProfile.current.contains(event.target as Node)) {
        setOpenProfile(false);
        // profileHandler()
        profileHandlerOutside(modalid ?? "")
      }
      if (hamburgerProfileRef.current && hamburgerMenuRef.current && !hamburgerProfileRef.current.contains(event.target as Node) && !hamburgerMenuRef.current.contains(event.target as Node)) {
        setOpenHamburgerProfile(false);
        // profileHandler()
        profileHandlerOutside(modalid ?? "")
      }
      if (successModalRef.current && !successModalRef.current.contains(event.target as Node)) {
        setProfileModals(prev => ({ ...prev, success: false, }))
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const tooltipArr: StaticTooltipTy[] = [
    { content: "What's new?", toolTipid: "tooltip-whatsNew", place: "bottom" },
    { content: "Project Dashboard", toolTipid: "prject_dashboard", place: "right" },
    { content: "Order Status", toolTipid: "order_list", place: "right" },
    { content: "Profile", toolTipid: "tooltip-profile", place: "bottom", isopen: true },]

  const [uploadFile, setUploadFile] = useState<File | string>("")
  const [uploadFileNames, setUploadFileNames] = useState<FileData[]>([])

  const handleSupportFileChange = (files: FileData[]) => {
    setUploadFileNames(files);                        // FileData[] → for VInputUpload display
    const actualFile = files?.[0]?.file ?? "";
    setUploadFile(actualFile);                        // actual File → for FormData

    if (actualFile && error["uploadFile" as keyof object]) {
      setError((prev: any) => {
        const newErrors = { ...prev };
        delete newErrors["uploadFile"];
        return newErrors;
      });
    }
  };

  const handleSupportProfileEdit = () => {
    handleViewProfileModalClose("support")

    dispatch(setModalHeaderFooter({ title: "Account Information", btnTxt: "Save", secondaryBtnTxt: "", modalid: ModalId.UserProfileEditModeSupport, isheader: true }));

    //  dispatch(setModalHeaderFooter({ title: "User Profile", btnTxt: "Save", secondaryBtnTxt: "Cancel", isheader: true }));
    setIsEditing(prev => ({ ...prev, view: true }))
    setProfileModals(prev => ({ ...prev, ["view"]: true }))

    // openViewProfileModal("view")
  }

  const [stepApproval, setStepApproval] = useState(1)

  const finalprojectiscompleted = async () => {
    try {
      if (selected_project && Object.keys(selected_project).length > 0) {
        let reqBody: any = { consumer_mainprojectstatus: selected_project?.consumer_mainprojectstatus === 1 || selected_project?.consumer_mainprojectstatus===0 ? 2 : selected_project?.consumer_mainprojectstatus };
        const payload = await dispatch(saveConsumerProjects({ reqBody, projectid: selected_project.projectid }));
        //  debugger
        if ((payload as any)?.meta?.requestStatus === "fulfilled") {
          //  dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
          Toast({ messageText: "Project book payment completed successfully ", messageType: "S", toastId: FORMTOASTERRID });
        } else {
          //  setLoadingFinalProceed(false)
          //  dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
          Toast({ messageText: "Failed to save final project complete!", messageType: "E", toastId: FORMTOASTERRID });
        }
      }
    } catch (error) {
      // setLoadingFinalProceed(false)
      // dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
      Toast({ messageText: "Failed to completed project book payment!", messageType: "E", toastId: FORMTOASTERRID });
    }

  }

  const confirmPaymentForProject = async () => {
    const projectId = selected_project?.projectid;
    if (!projectId) {
      Toast({ messageText: "Project not found. Please reopen the project and try again.", messageType: "E", toastId: FORMTOASTERRID });
      return;
    }
    setProceedToPaymentLoading(true)
    try {
      // Creating the order is not a payment: the booking is completed only after PayU's verified callback
      // Leaves the app; PayU → backend callback → /payment/result → back here, handled by the effect below
      await startPayUCheckout({
        packageId: PROPOSAL_PAYMENT_PACKAGE_ID, featureId: null, billingBasis: BillingBasis.OneTimeProject,
        quantity: 1, projectId, couponCode: null,
      }, pathname, { type: "proposal", projectId });
    } catch (error) {
      Toast({ messageText: paymentErrorMessage(error), messageType: "E", toastId: FORMTOASTERRID });
      setProceedToPaymentLoading(false)
    }
  }

  // Complete a paid proposal booking and show its success screen:
  // - back from PayU in this tab: re-check that transaction with the server;
  // - otherwise (PayU returned to another site, tab closed, other device): if the project has a proposal but
  //   isn't booked yet, ask the server whether a successful booking payment exists for it (once per project)
  const bookingCheckedRef = useRef<string | null>(null);
  useEffect(() => {
    const projectId = selected_project?.projectid;
    if (!projectId) return;
    const transactionId = takeCompletedPayment({ type: "proposal", projectId });
    const awaitingBooking = !!selected_project?.proposalfilepath && (selected_project?.consumer_mainprojectstatus ?? 0) < 2;
    if (!transactionId && (!awaitingBooking || bookingCheckedRef.current === projectId || hasUnconfirmedPayment())) return;
    bookingCheckedRef.current = projectId;
    (async () => {
      try {
        const paid = transactionId
          ? (await getPaymentStatus(transactionId)).status === "Success"
          : (await hasPaidPackageForProject(PROPOSAL_PAYMENT_PACKAGE_ID, projectId)).paid;
        if (!paid) return;
        await finalprojectiscompleted();
        setStepApproval(4);
        dispatch(setModalHeaderFooter({ title: "Secure your solar installation", btnTxt: "Go to Dashboard", secondaryBtnTxt: "", modalid: "proposalreview" }));
      } catch (error) {
        Toast({ messageText: paymentErrorMessage(error), messageType: "E", toastId: FORMTOASTERRID });
      }
    })();
  }, [selected_project?.projectid]);

  return (
    <>
      {/* Profile options modals */}
      <>

        <UserProfilePortal />

      </>


      {/* {profileModals.support && (<NewModal maxheight="69vh" isAbleCLick onClick={handleSupport} setIsCLose={() => handleViewProfileModalClose("support")} name={"Support"} isLoading={isModalLoading === "User Profile"} */}
      {modalid === "supportsystem" && (<NewModal maxheight="69vh" isAbleCLick onClick={handleSupport} setIsCLose={() => handleViewProfileModalClose("support")} name={"Support"} isLoading={isModalLoading === "User Profile"}
        children={<Support supportSuccess={supportSuccess} isEditing={!isEditing.support} openViewProfileModal={openViewProfileModal} handleProfileEdit={handleSupportProfileEdit} profileState={supportDetails} error={error} handleChange={(e: any, selectedOption?: any) => handleChange(e, "support", selectedOption)}
          uploadFileNames={uploadFileNames} setUploadFileNames={handleSupportFileChange} />} modalSize="lg" btnName="support" />)}

      {profileModals.supporttrack && (<NewModal scrollhide maxheight="70vh" modalSize="smlg" isAbleCLick btnName="" onClick={() => { }} setIsCLose={() => openViewProfileModal(null)} name={"Track Request"} children={<SupportTrack />} />)}

      {/* {modalid === "proposalreview" && ( <ProposalModal stepApproval={stepApproval}  isOpen={true}  onClose={() => openViewProfileModal(null)}  onSupportOpen={() => openViewProfileModal("support")} /> )} */}
      {modalid === "proposalreview" && (<ProposalModal stepApproval={stepApproval} setStepApproval={setStepApproval} isOpen={true} onClose={() => { openViewProfileModal(null); setStepApproval(1) }} onSupportOpen={() => openViewProfileModal("support")} onPay={confirmPaymentForProject} isPaying={proceedToPaymentLoading} />)}

      {/* {modalid === "paymentcheckoutapproval" && <NewModal isFooterRequired={false} modalSize={"sm"} isLoading={false} name={"Big sun, big savings"} btnName={"Button Name"} maxheight="fit-content" onClick={()=>{}} isAbleCLick={true} children={<PaymentCheckout />} setIsCLose={() => openViewProfileModal(null)} />} */}

      {/* 
      {profileModals.view && (<NewModal isAbleCLick onClick={handleViewProfileUpdate} setIsCLose={() => handleViewProfileModalClose("view")} name={"Profile Details"} children={<ProfileModal isEditing={!isEditing.view}
        handleMobileNumber={handleMobileNumber} setProfileState={setViewProfileDetails} error={error} profileState={viewProfileDetails} handleChange={(e: any) => handleChange(e, "profile")} />} modalSize="lg" btnName="profile" />)}
      {profileModals.success && (<SuccessModal setState={setProfileModals} Message={profileModals.message} />)}
      {profileModals.setting && (<NewModal height="50vh" isAbleCLick onClick={handleSettingsUpdate} isFooterRequired={false} setIsCLose={() => handleViewProfileModalClose("setting")} name={"Settings"} children={<SettingModal handleChange={(props: any, tabname: string) => handleSettings(props, tabname)} currency={currency} isEditing={!isEditing.setting} units={units} />} modalSize="lg" btnName="setting" />)}


      {profileModals.password && (<NewModal maxheight="70vh" isAbleCLick onClick={handleChangePasswordClick} setIsCLose={() => handleViewProfileModalClose("password")} name={"Profile Details"} children={<ChangePassword setPasswordHide={setPasswordHide} passwordHide={passwordHide}
        changePasswordIn={changePasswordIn} handleChange={(e: any, i: number) => handlePasswordChangeEl(e, i)} error={error} />} modalSize="md" btnName="profile" />
       )} */}

      {/* Modals */}
      {/* <MyAddress /> */}

      <div className="flex  items-center px-4 py-0.5 relative bg-white h-[70px] gap-2 ">
        {/* <InfoModal /> */}
        <button type="button" className="w-fit max-lg:block flex-shrink-0" onClick={handleClickLogo} aria-label="Logo Button" > <img src={logoImage} alt="logo" className="h-full w-40" /></button>
        <div>

        </div>
        {/* { selected_project && (
        <button
          type="button"
          className="w-fit para-md text-custom-primary-default cursor-pointer w-max bg-red-500 text-white py-1 px-3 font-light rounded-sm flex-shrink-0"
          onClick={fetchIframeAnalysis}
          aria-label="fetch 3d"
        >
          {show ? 'Remove' : 'Get 3D Analysis'}
        </button>
        )} */}

        <div id="collapseMenu" className="w-full max-[750px]:hidden min-[750px]:!block max-[750px]:fixed max-[750px]:before:fixed max-[750px]:before:bg-black max-[750px]:before:opacity-50 max-[750px]:before:inset-0 max-[750px]:before:z-50" >
          <button id="toggleClose" className=" min-[750px]:hidden fixed top-2 right-4 z-[100] rounded-full bg-white p-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 fill-black" viewBox="0 0 320.591 320.591" >
              <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                data-original="#000000" ></path>
              <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                data-original="#000000" ></path>
            </svg>
          </button>

          <div className="fixed bg-white w-1/2 min-w-[300px] top-0 left-0 py-6 h-full shadow-md overflow-auto z-50 min-[750px]:static min-[750px]:flex min-[750px]:w-auto min-[750px]:h-auto min-[750px]:bg-transparent min-[750px]:shadow-none " >
            <ul className="min-[750px]:flex min-[750px]:gap-x-4 max-[750px]:space-y-2 items-center">
              {/* <div className="flex justify-start items-center gap-3"> */}
              {/* <div className="m-auto max-lg:hidden cursor-pointer" onClick={handleClickLogo}> <img src={fp_logo} alt="logo" className="size-9" /> </div> */}
              {/* {headerTitle && (
                <div className="max-h-9 w-px self-stretch bg-gradient-to-tr from-transparent via-neutral-600 to-transparent opacity-25 "></div>
              )} */}
              {/* <div className="para-sm text-gray-700">{headerTitle}</div> */}
              {/* </div> */}

              {/* {userType === "Consumer" &&
              pathname === "/Consumer/RoofAnalysis" && (<>
                <div className="max-h-9 w-px self-stretch bg-gradient-to-tr from-transparent via-neutral-600 to-transparent opacity-25 "></div>
                <div className="searchInHeader" id="searchDiv"></div>
              </>
              )} */}
            </ul>

            {/* <div className="lg:flex lg:space-x-4 max-lg:space-y-2 max-lg:mt-2 ml-auto"> */}
            <div className="min-[750px]:flex min-[750px]:space-x-4 max-[750px]:space-y-2 max-[750px]:mt-2 ml-auto" style={{ pointerEvents: modalTitle || !user?.userid ? "none" : "auto" }}  > { /* || isState !== "successfull" */}
              {userType === "Consumer" && pathname === "/Consumer/RoofAnalysis" && (
                <>
                  <div className="searchInHeader" id="searchDiv"></div>
                  <div className="max-h-9 w-px self-stretch bg-gradient-to-tr from-transparent via-neutral-600 to-transparent opacity-25 "></div>
                </>
              )}
              <ul className="flex items-center gap-3">
                {/* <li
                  data-tooltip-id="tooltip-whatsNew"
                  className="cursor-pointer"
                >
                  <WhatsNewIcon className="size-[30px]" />
                </li> */}
                {/* <button className="btn btn-md-primary" onClick={() => openViewProfileModal("proposal")}>Proposal</button> */}
                <li className="cursor-pointer"> {/* onClick={profileHandler} */}
                  <div>
                    {viewProfileDetails.profileimage.size !== 0 &&
                      viewProfileDetails.profileimage !== "" &&
                      viewProfileDetails.profileimage !== undefined ? (
                      <div onClick={profileHandler} ref={headerProfile} className="cursor-pointer  rounded-full border-[0.3vh] border-custom-primary-default z-10" >
                        <img src={URL.createObjectURL(viewProfileDetails.profileimage)} alt="Selected" style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "4vh", height: "4vh", borderRadius: "100%", }} />
                      </div>
                    ) : (
                      <span onClick={profileHandler} ref={headerProfile} data-tooltip-id="tooltip-profile" >
                        {/* <ProfileIcon className="size-8" /> */}
                        <span ref={headerProfile} className="inline-flex items-center justify-center size-8 para-sm-semibold rounded-full text-gray-100 bg-custom-primary-default shadow-sm uppercase cursor-pointer"> {uname && uname.fname + uname.lname} </span>
                      </span>)}
                    {/*  <span ref={headerProfile} className="inline-flex items-center justify-center size-10 para-sm-semibold rounded-full  border-[0.3vh] border-custom-primary-default text-custom-primary-default shadow-sm uppercase cursor-pointer"> {uname && uname.fname + uname.lname} </span>}
              {/* <span className="inline-flex items-center justify-center size-10 para-sm-semibold rounded-full border border-custom-primary-default text-custom-primary-default shadow-sm uppercase cursor-pointer"> {uname && uname.fname + uname.lname} </span> */}

                    {/* {openProfile && (<ProfileOptionModal profileContainerRef={profileModalRef} uname={uname} logout={logout} user={user} openViewProfileModal={openViewProfileModal} profileimage={viewProfileDetails.profileimage} />)} </div> */}
                    {modalid === "profileoptionmodal" && (<ProfileOptionModal profileContainerRef={profileModalRef} uname={uname} logout={logout} user={user} openViewProfileModal={openViewProfileModal} profileimage={viewProfileDetails.profileimage} />)} </div>

                </li>
              </ul>
            </div>
          </div>
        </div>
        <div ref={hamburgerMenuRef} className="flex ml-auto min-[750px]:hidden" >
          <button id="toggleOpen" onClick={() => setOpenHamburgerProfile((prev) => !prev)}>
            <HamburgerMenuIcon />
          </button>
          {openHamburgerProfile && (<ProfileOptionModal profileContainerRef={hamburgerProfileRef} uname={uname} logout={logout} user={user} openViewProfileModal={openViewProfileModal} profileimage={viewProfileDetails.profileimage} />)}
        </div>
      </div>
      {tooltipArr.map((tooltip) => (<div className="relative"> <ReactTooltip Side="LSB" place={tooltip?.place ?? "bottom"} id={tooltip.toolTipid} content={tooltip.content} /> </div>))}
    </>

    /*  <div className={`grid ${(pathname==="/Partner/RoofAnalysis"||pathname==="/Admin/RoofAnalysis"||pathname==="/Consumer/RoofAnalysis")?"grid-cols-3":"grid-cols-2"} gap-4 content-center h-[7vh]`}>
      <div className="flex justify-start items-center ">
        <div className=" text-1.8xl text-yellow-200 font-medium px-2 leading-[2vh]">pvNXT</div>
        {headerTitle&&<div className="h-[2.6vh] border-r-[0.2vh] border-yellow-200/40"></div>}
        <div className="flex flex-col justify-between px-2">
          <div className="text-1.8xl text-yellow-200 font-medium">
            {headerTitle}
            {/* {pathname.includes("Projects")?"Project Dashboard":titleActive!="" ? HeaderListItems[titleActive as keyof typeof HeaderListItems]?.headerName:"Rooftop Analytical Portal"}
            {/* {titleActive!=""? titleActive:"Rooftop Analytical Portal"}           
          </div>
        </div>
      </div>
      {(userType==="Partner"&&pathname==="/Partner/RoofAnalysis")&&<div className="searchInHeader" id="searchDiv"></div>}
      {(userType==="Admin"&&pathname==="/Admin/RoofAnalysis")&&<div className="searchInHeader" id="searchDiv"></div>}
      {(userType==="Consumer"&&pathname==="/Consumer/RoofAnalysis")&&<div className="searchInHeader" id="searchDiv"></div>}
      <div className="flex justify-end items-center px-0.8">
        <div title="Language" className="text-1.6xl font-medium text-white cursor-pointer">EN</div>
        <div className="h-[2.6vh] border-r-[0.2vh] border-yellow-200/40 mx-1 cursor-pointer"></div>
        <div title="Support Center" className="cursor-pointer" onClick={handleSupport}> *
        <a title="Support Center" className="cursor-pointer" target="_blank" href="mailto:support@terranxt.com"><IconHelp /></a>
        {/* </div> 
    </>*/
  );
};

export default DefaultHeader;
